// @ts-nocheck
import _ from 'lodash';
import axios from 'axios';
import { create } from 'zustand';
import { API_URL } from '../configs';
import { toastTypes } from '../enums';
import getRoot from './root';

const useAccountStatusStore = create((set, get) => ({
  account: {},
  planObj: {},
  loading: false,

  reset: () => set({ account: {}, planObj: '' }),

  getAccountDetails: async () => {
    const root = getRoot();
    try {
      const res = await axios.get(`${API_URL}/api/payments/account-details`);
      if (res.data.success && res.data.paymentData && !res.data.paymentData.deleted) {
        const account = res.data.paymentData;
        const planObj = _.get(account, ['subscriptions', 'data', '0', 'items', 'data', '0', 'plan']);
        set({ account, planObj });
      } else {
        set({ account: {} });
      }
    } catch (e) {
      root.failure('Could not get account details.');
    }
  },

  cancelSubscription: async () => {
    const root = getRoot();
    try {
      set({ loading: true });
      const res = await axios.delete(`${API_URL}/api/payments/cancel-subscription`);
      get().getAccountDetails();
      if (res.data.success) {
        root.success('Your Subscription will conclude after the billing cycle.', toastTypes.cancelSubscription);
        root.clearToast(toastTypes.cancelSubscription);
        get().getAccountDetails();
      } else {
        root.failure('Update Failed.', toastTypes.cancelSubscription);
      }
    } catch (e) {
      root.failure('Could not cancel your subscription.', toastTypes.cancelSubscription);
    } finally {
      get().getAccountDetails();
      set({ loading: false });
    }
  },
}));

export default useAccountStatusStore;
